import { render, staticRenderFns } from "./EditStockLayer.vue?vue&type=template&id=f5272468&scoped=true&"
import script from "./EditStockLayer.vue?vue&type=script&lang=js&"
export * from "./EditStockLayer.vue?vue&type=script&lang=js&"
import style0 from "./EditStockLayer.vue?vue&type=style&index=0&id=f5272468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5272468",
  null
  
)

export default component.exports